import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { SharedModule } from "src/app/shared/shared.module";
import { DayProductionComponent } from "./dayproduction/dayproduction";

@NgModule({
  imports: [
    BrowserModule,
    SharedModule,
  ],
  declarations: [
    DayProductionComponent,
  ],
  exports: [
    DayProductionComponent,
  ],
})
export class Common_DayProduction { }
